<template>
  <vf-media-gallery
    v-if="product"
    :items="galleryItems"
    pagination
    :product-id="productId"
    @zoom="onZoom"
  >
    <template #default="{ i }">
      <div class="absolute bottom-0 left-0 m-3 f-col items-start gap-4 lg:m-6">
        <base-button
          v-if="(productHasTryItOnAsset && showTryItOnCtaOnPDP) && i === 0"
          id="pdp-try-it-on"
          class="body-4 flex center gap-2 bg-white/70 p-2 c-black backdrop-blur-md"
          @click="tryItOn"
        >
          <vf-icon name="try-it-on" size="md" />
          <span>{{ $t.tryItOn }}</span>
        </base-button>
        <p
          v-if="product.modelMeasurements?.length && i === (galleryItems.length > 2 ? 2 : 0)"
          class="body-4 pointer-events-none w-fit bg-white/70 p-2 backdrop-blur-md"
        >
          {{ product.modelMeasurements[0] }}
        </p>
      </div>
    </template>
  </vf-media-gallery>
</template>

<script setup lang="ts">
const { showTryItOnCtaOnPDP } = useFeatureFlags()
const { galleryItems, onZoom, product, productId, tryItOn } = usePdp()

const tryItOnProducts = ref()

const productHasTryItOnAsset = computed(() => product.value?.id
  && tryItOnProducts.value?.includes(product.value.id.toLowerCase()))

if (showTryItOnCtaOnPDP) {
  try {
    const { data } = await useApi().internal.getStaticPage('vyking-products')
    tryItOnProducts.value = data.value
  }
  catch { tryItOnProducts.value = [] }
}
</script>
